
import Vue from "vue";
import store from "@/store";
import { LOYALTY } from "@/store/loyalty";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { ICustomerCard, OfferLevelType } from "@/store/loyalty/types";
import { associationAccess } from "@/helpers/loyaltyEditAccess";
import { isInRole } from "@/helpers/auth";
import {
  TELNET
} from "@/constants/roles";

export default Vue.extend({
  props: {
    items: Array,
    customerId: Number,
    showCardUpdate: Boolean,
    customerLevel: String
  },
  computed: {
    pagination: {
      get() {
        return store.state.loyalty.dataTables.customerCards.pagination;
      },
      set(value: string) {
        this.$store.commit(
          LOYALTY.NS(LOYALTY.MUTATIONS.SET_CUSTOMER_CARDS_PAGINATION),
          value
        );
      }
    },
    hasEditAccess() {
      return associationAccess();
    },
    offerLevel() {
      return this.customer && this.customer.offer && this.customer.offer.level;
    },
    hasOnlyTelnetRole() {
      const roles: string[] = this.$store.state &&
        this.$store.state.auth &&
        this.$store.state.auth.roles;

      return (
        roles &&
        roles.length &&
        roles.every((role: string) => role === TELNET)
      );
    },
    ...mapState({
      customer: (state: IRootState) => state.loyalty.customer,
      paginationTotal: (state: IRootState) =>
        state.loyalty.customerCardsListPaginationTotal,
      activeCustomerCard: (state: IRootState) =>
        state.loyalty.activeCustomerCard,
      uiIsLoading: (state: IRootState) => state.loyalty.isLoading,
    })
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      currentCustomerCard: null,
      currentEventType: null,
      headers: [
        { text: "Card number", value: "cardNumber" },
        { text: "Card status", value: "cardStatus" },
        { text: "Expiry", value: "expiry" },
        { text: "Rego", value: "rego" },
        { text: "Driver name", value: "driverName" },
        { text: "Cost centre code", value: "costCentreCode" },
        { text: "Loyalty number", value: "loyaltyNumber" },
        { text: "Loyalty scheme", value: "loyaltyScheme" },
        {
          text: (this as any).hasEditAccess ? "Update loyalty number" : "",
          value: "",
          sortable: false
        }
      ]
    };
  },
  methods: {
    updateLoyaltyActions(costCentreCode: string) {
      const actions = [];
      const offerLevel = (this as any).offerLevel;
      // ZBIZ-219 prevent telnet users from changing from different Accumulation level
      if ((this as any).hasOnlyTelnetRole) {
        if (offerLevel === OfferLevelType.Card) {
          return [{ value: OfferLevelType.Card, text: "this card" }];
        }
        if (costCentreCode && OfferLevelType.CostCentre === offerLevel) {
          return [{ value: OfferLevelType.CostCentre, text: "this cost centre" }];
        }
        if (OfferLevelType.Account === offerLevel) {
          return [{ value: OfferLevelType.Account, text: "this account" }];
        }
        return null; // Don't fall back to account for Telnet users
      }
      if (offerLevel === OfferLevelType.Card) {
        actions.push({ value: OfferLevelType.Card, text: "this card" });
      }
      if (
        costCentreCode &&
        [OfferLevelType.Card, OfferLevelType.CostCentre].includes(
          offerLevel
        )
      ) {
        actions.push({
          value: OfferLevelType.CostCentre,
          text: "this cost centre"
        });
      }

      // account option is always available
      actions.push({ value: OfferLevelType.Account, text: "this account" });
      return actions;
    },
    onLoyaltyAction(customerCard: ICustomerCard, eventType: any) {
      // ZBIZ-219: Indicate to users that this change will cause effect at a different accumulation level
      if (eventType !== (this as any).customerLevel) {
        (this as any).showModal = true;
        (this as any).currentCustomerCard = customerCard;
        (this as any).currentEventType = eventType;
      } else {
        (this as any).showChangeCustomerCard(customerCard, eventType);
      }
    },
    confirmDifferentAccumulationLevelChanges() {
      (this as any).showChangeCustomerCard((this as any).currentCustomerCard, (this as any).currentEventType);
      (this as any).closeDifferentAccumulationLevelChanges();
    },
    closeDifferentAccumulationLevelChanges() {
      (this as any).showModal = false;
      (this as any).currentCustomerCard = null;
      (this as any).currentEventType = null;
    },
    showChangeCustomerCard(customerCard: ICustomerCard, eventType: any) {
      (this as any).$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.SET_ACTIVE_CUSTOMER_CARD), {
        ...customerCard,
        ...{
          accountNumber: (this as any).customerId,
          dialogType: eventType
        }
      }
      );
    },
    async onPagination(pagination: any) {
      const customerId = (this as any).customerId;
      (this as any).isLoading = true;
      if (customerId) {
        await this.$store.dispatch(
          LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CUSTOMER_CARDS),
          {
            customerId
          }
        );
      }
      (this as any).isLoading = false;
    }
  }
});
